/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Auth_Error_TitleInputs */



/**
* | output |
* | --- |
* | "Authorization Error" |
*
* @param {Creator_Auth_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_auth_error_title = /** @type {((inputs?: Creator_Auth_Error_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Auth_Error_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur d'autorisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Autorisierungsfehler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore di autorizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка авторизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de autorización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("授权错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("認証エラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्राधिकरण त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro de autorização")
	return /** @type {LocalizedString} */ ("Authorization Error")
});